if (!customElements.get('roomix-steps')) {
  customElements.define('roomix-steps', class roomixSteps extends HTMLElement {
    constructor() {
      super();
      this.continueStepButton = document.querySelector('.product-form__continue');
      this.steps = this.querySelectorAll('.step');

      if (document.body.classList.contains('product-steps-addons')) {
        this.addonSummary = document.querySelectorAll('.addon-summary');

        this.addOnStepsContainer = document.querySelector('.addon-steps-container');
        this.productDetails = document.querySelector('.product-details');
        this.productMediaWrapper = document.querySelector('.product__media-wrapper');
        this.productTitle = document.querySelector('.product__title');
        this.productSubtitle = document.querySelector('.product__text.subtitle');
        this.productRating = document.querySelector('#shopify-block-loox-rating');
        this.productReviews = document.querySelector('#shopify-block-loox-product-reviews');
        this.productDescription = document.querySelector('.product__description');

        this.videoSection = document.querySelector('.video-section');
        this.productRecommendations = document.querySelector('.pr-container');

        this.multicolumnSections = document.querySelectorAll('.multicolumn');

        this.buyButtonWrapper = document.querySelector('.buy_button_wrapper');

        this.submitButton = document.querySelector('product-form .product-form__submit')

        this.summaryContent = document.querySelector('.summary-content');
        this.summarySteps = document.querySelectorAll('[data-step]');

        this.continueStepButton.addEventListener('click', (event) => {
          this.onClickContinueStep();
        });
      }
    }

    connectedCallback() {
      const params = new URLSearchParams(window.location.search);
      const locked = params.get('lock') === 'true';
      const deliveryDateStepEl = document.getElementById('deliveryDateStep');
      const delivery_calendar = params.get('delivery') === 'true'
        || (deliveryDateStepEl && ((deliveryDateStepEl.getAttribute('data-init-metafields') || deliveryDateStepEl.dataset.initMetafields || '').toLowerCase() === 'true'));
      const variantParam = params.get('variant');

      const parseStepParams = () => {
        const steps = [];
        for (const [k, v] of params.entries()) {
          const m = k.match(/^step_(\d+)$/);
          if (m) steps.push({ index: m[1], value: v });
        }
        return steps;
      };

      const dispatchEventOn = (node, type) => {
        if (!node) return;
        const ev = new Event(type, { bubbles: true });
        node.dispatchEvent(ev);
      };

      const trySelectByIndex = (currentStep, value) => {
        const n = Number(value);
        const kitInputs = currentStep.querySelectorAll('optional-items input');
        if (!Number.isNaN(n) && kitInputs.length >= 1 && n >= 1 && n <= kitInputs.length) {
          kitInputs.forEach(i => { i.checked = false; dispatchEventOn(i, 'change'); });
          const target = kitInputs[n - 1];
          target.checked = true;
          dispatchEventOn(target, 'change');
          return true;
        }
        return false;
      };

      const trySelectVariant = (currentStep, value) => {
        const variantEl = currentStep.querySelector('variant-selects');
        if (!variantEl) return false;
        if (value) return true;
        const existing = variantEl.getAttribute('variant') || variantEl.dataset.variant || variantEl.value;
        return !!existing;
      };

      const applyStepSelection = (index, value) => {
        const currentStep = document.querySelector(`.step #step-${index}`);
        if (!currentStep) return;

        let applied = false;
        applied = trySelectByIndex(currentStep, value) || applied;
        applied = trySelectVariant(currentStep, value) || applied;

        if (!applied) {
          const radios = currentStep.querySelectorAll('input[type="radio"], input[type="checkbox"]');
          if (radios.length === 1 && (value === '1' || (value.toLowerCase && value.toLowerCase() === 'true') || value !== '0')) {
            radios[0].checked = true;
            dispatchEventOn(radios[0], 'change');
          }
        }
      };

      // updated: when locking a step, keep checked controls and anything inside variant-selects enabled
      const applyLock = (lockedIndices = []) => {
        if (!Array.isArray(lockedIndices) || lockedIndices.length === 0) return;

        if (variantParam) {
          const step1 = this.querySelector('.step #step-1') || document.querySelector('.step #step-1');
          if (step1) {
            const radios = step1.querySelectorAll('input[type="radio"]');
            radios.forEach((r) => {
              if (!r.checked && r.type !== 'hidden') {
                r.disabled = true;
                const label = r.closest('label') || document.querySelector(`label[for="${r.id}"]`);
                if (label) label.classList.add('disabled');
              }
            });
          }
          // continue to also handle any other locked indices below
        }

        if (!Array.isArray(lockedIndices)) lockedIndices = [];

        lockedIndices.forEach((index) => {
          const stepAnchor = this.querySelector(`.step #step-${index}`) || document.querySelector(`.step #step-${index}`);
          if (!stepAnchor) return;
          const container = stepAnchor.closest('.step') || stepAnchor.parentElement;
          if (!container) return;

          // include selects, textarea, buttons as well
          const controls = container.querySelectorAll('input, select, textarea, button');
          controls.forEach((el) => {
            // skip elements inside a variant-selects component (component handles its own UI)
            const variantEl = container.querySelector('variant-selects');
            if (variantEl && variantEl.contains(el)) return;

            // never disable hidden inputs or already checked inputs
            if (el.tagName === 'INPUT') {
              if (el.type === 'hidden' || el.checked) return;
              el.disabled = true;
            } else {
              // disable selects, textarea, buttons for locked steps
              el.disabled = true;
            }

            const label = el.closest('label') || (el.id ? document.querySelector(`label[for="${el.id}"]`) : null);
            if (label) label.classList.add('disabled');
          });
        });
      };

      if (delivery_calendar) {
        // try common selectors for your calendar container
        const deliveryContainer = document.querySelector('.step.delivery-date-step');

        if (deliveryContainer) {
          // unhide the container if it was hidden by CSS
          deliveryContainer.classList.remove('hidden');
          document.querySelector('roomix-summary .summary-step.delivery-summary').classList.remove('hidden');
          deliveryContainer.querySelector('delivery-calendar').dataset.deliveryOnOrder = 'true';
        }
      }

      const applyAllFromUrl = () => {
        const steps = parseStepParams();

        // apply any selections provided via URL (if none, this is a no-op)
        steps.forEach(s => applyStepSelection(s.index, s.value));

        const summary = document.querySelector('roomix-summary');
        if (summary && typeof summary.updateSteps === 'function') {
          setTimeout(() => summary.updateSteps(), 50);
        }

        if (locked) {
          const lockedIndices = steps.map(s => s.index);
          setTimeout(() => applyLock(lockedIndices), 60);
        }
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', applyAllFromUrl, { once: true });
      } else {
        applyAllFromUrl();
      }
    }

    onClickContinueStep() {
      document.querySelector('.main-steps-container').classList.add('hidden');
      this.continueStepButton.classList.add('hidden');

      if (document.querySelector('.included-items--wrapper')) {
        document.querySelector('.included-items--wrapper').classList.add('hidden');
      }
      this.productDetails.classList.add('hidden');
      this.productMediaWrapper.classList.add('hidden');

      this.productTitle.classList.add('hidden');
      this.productSubtitle.classList.add('hidden');

      if (this.productRating) {
        this.productRating.classList.add('hidden');
      }

      this.productDescription.classList.add('hidden');

      if (this.productReviews) {
        this.productReviews.classList.add('hidden');
      }

      if (this.videoSection) {
        this.videoSection.classList.add('hidden');
      }

      if (this.productRecommendations) {
        this.productRecommendations.classList.add('hidden');
      }

      if (document.querySelector('.pb-to-hide')) {
        document.querySelector('.pb-to-hide').classList.add('hidden');
      }
      if (document.querySelector('.collapsible-content.content-container--full-width')) {
        document.querySelector('.collapsible-content.content-container--full-width').classList.add('hidden');
      }

      this.multicolumnSections.forEach((section) => {
        section.classList.add('hidden');
      });

      this.addOnStepsContainer.classList.remove('hidden');
      this.buyButtonWrapper.classList.remove('hidden');
      this.addonSummary.forEach((summary) => {
        summary.classList.remove('hidden');
      });

      setTimeout(() => {
        this.addOnStepsContainer.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
      }, 200)
    }

  });
}

if (!customElements.get('roomix-summary')) {
  customElements.define('roomix-summary', class roomixSummary extends HTMLElement {
    constructor() {
      super();
      this.mainSteps = document.querySelector('roomix-steps');
      this.summarySteps = this.querySelectorAll('[data-step]');
      this.summaryEditStep = this.querySelectorAll('[data-edit-step]');

      this.openSummaryMobile = this.querySelector('.open-summary-mobile');
      this.summaryCloseButton = this.querySelector('.summary-close-button');
      this.summaryContent = this.querySelector('.summary-content');

      this.openSummaryMobile.addEventListener('click', (event) => {
        this.summaryContent.classList.add('active');
        this.classList.add('active');
        this.classList.remove('display-summary-mobile-button');
      });

      this.summaryCloseButton.addEventListener('click', (event) => {
        this.classList.add('display-summary-mobile-button');
        this.summaryContent.classList.remove('active');
        this.classList.remove('active');
      });

      this.summaryEditStep.forEach((step) => {
        step.addEventListener('click', (event) => {
          let index = step.dataset.editStep;
          let stepToEdit = this.mainSteps.querySelector(`.step #step-${index}`);
          if (stepToEdit.parentElement.parentElement.classList.contains('hidden')) {
            stepToEdit.parentElement.parentElement.classList.remove('hidden');

            if (document.querySelector('.included-items--wrapper')) {
              document.querySelector('.included-items--wrapper').classList.remove('hidden');
            }
            if (document.querySelector('.product-details')) {
              document.querySelector('.product-details').classList.remove('hidden');
            }
            if (document.querySelector('.product__media-wrapper')) {
              document.querySelector('.product__media-wrapper').classList.remove('hidden');
            }
            if (document.querySelector('.product__title')) {
              document.querySelector('.product__title').classList.remove('hidden');
            }
            if (document.querySelector('.product__text.subtitle')) {
              document.querySelector('.product__text.subtitle').classList.remove('hidden');
            }
            if (document.querySelector('#shopify-block-loox-rating')) {
              document.querySelector('#shopify-block-loox-rating').classList.remove('hidden');
            }
            if (document.querySelector('.product__description')) {
              document.querySelector('.product__description').classList.remove('hidden');
            }
            if (document.querySelector('#shopify-block-loox-product-reviews')) {
              document.querySelector('#shopify-block-loox-product-reviews').classList.remove('hidden');
            }
            if (document.querySelector('.video-section')) {
              document.querySelector('.video-section').classList.remove('hidden');
            }
            if (document.querySelector('.pb-to-hide')) {
              document.querySelector('.pb-to-hide').classList.remove('hidden');
            }
            if (document.querySelector('.collapsible-content.content-container--full-width')) {
              document.querySelector('.collapsible-content.content-container--full-width').classList.remove('hidden');
            }
            if (document.querySelector('.pr-container')) {
              document.querySelector('.pr-container').classList.remove('hidden');
            }

            document.querySelectorAll('.multicolumn').forEach((section) => {
              section.classList.remove('hidden');
            });
            document.querySelectorAll('.product__description').forEach((section) => {
              section.classList.remove('hidden');
            });
          }

          if (stepToEdit.nodeName === 'DETAILS') {
            stepToEdit.open = true;
          }

          stepToEdit.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
          this.classList.add('display-summary-mobile-button');
        });
      });
    }
    connectedCallback() {
      setTimeout(() => {
        this.updateSteps();
      }, 200);
    }

    getCollectionInfo(index, step) {
      let currentStep = this.mainSteps.querySelector(`.step > #step-${index}`)
      let productName = '';
      if (currentStep.querySelector('optional-items')) {
        productName = currentStep.querySelector('input:checked').dataset.productName;
        step.querySelector('span').innerHTML = productName;
      } else {
        step.querySelector('span').innerHTML = currentStep.querySelectorAll('.kit-list input:checked').length + ' items';
      }
      const quantityElement = currentStep.querySelector('quantity-input input');
      const quantityHolder = currentStep.querySelector('.quantity-handle');
      if (quantityElement && quantityHolder.classList.contains('hidden') === false) {
        step.querySelector('.summary-quantity span').innerHTML = quantityElement.value;
        let quantitySummaryDisplay = step.querySelector('.summary-quantity');
        if (productName === 'No Paint') {
          quantitySummaryDisplay.classList.add('hidden');
        } else {
          quantitySummaryDisplay.classList.remove('hidden');
        }
      }
    }

    getPropertiesInfo(index, step) {
      let currentStep = this.mainSteps.querySelector(`.step #step-${index}`)
      if (currentStep.querySelector('input:checked')) {
        step.querySelector('span').innerHTML = currentStep.querySelector('input:checked').value;
      }
      if (currentStep.querySelector('input[type="text"]')) {
        step.querySelector('span').innerHTML = currentStep.querySelector('input').value;
      }
    }


    getVariantsInfo(index, step) {
      let currentStep = this.mainSteps.querySelector(`.step #step-${index}`)
      let valuesSummary = ''

      currentStep.querySelectorAll('input:checked').forEach((input) => {
        valuesSummary += input.value + ' / '
      });
      currentStep.querySelectorAll('select').forEach((select) => {
        valuesSummary += select.value + ' / '
      })
      let innerHTML = '<span class="variant-values">' + valuesSummary.slice(0, -3) + '</span>';

      if (currentStep.querySelectorAll('variant-selects-matrix').length > 0) {
        let valuesManualInput = '';
        let valuesSummaryHTML = '';
        let enableTitle = false;
        currentStep.querySelectorAll('variant-selects-matrix fieldset').forEach((fieldset) => {
          if (fieldset.querySelector('select.select__select') || (fieldset.querySelector('input.manual-input') && fieldset.querySelector('input.manual-input').value !== '')) {
            enableTitle = true;
            let label
            if (fieldset.querySelector('legend span')) {
              label = fieldset.querySelector('legend span').innerText;
            } else {
              label = fieldset.querySelector('div.form__label').innerText;
            }
            let value = '';
            const select = fieldset.querySelector('select.select__select');
            if (select && select.value) {
              value = select.options[select.selectedIndex].text;
            } else if (fieldset.querySelector('input.manual-input')) {
              value = fieldset.querySelector('input.manual-input').value;
            }
            valuesManualInput += `${label.charAt(0).toUpperCase() + label.slice(1).toLowerCase()} ${value}cm`+ ' / '
          }
        });
        if (enableTitle) {
          valuesSummaryHTML = '<br><strong>Measurements:</strong>';
        }
        innerHTML += valuesSummaryHTML + valuesManualInput.slice(0, -2)
      }
      step.querySelector('span').innerHTML = innerHTML;

    }


    getCustomDimensionsInfo(index, step) {
      const currentStep = document.querySelector(`.step #step-${index}`);
      const length = currentStep.querySelector('#dynamic-length').value;
      const depth = currentStep.querySelector('#dynamic-depth').value;
      let quantity = 1;
      if (currentStep.querySelector('quantity-input input')){
        quantity = parseInt(currentStep.querySelector('quantity-input input').value)
      }
      const height = currentStep.querySelector('#dynamic-height') ? currentStep.querySelector('#dynamic-height').value : '';

      step.querySelector('span').innerHTML = `${length}x${depth}${height ? 'x' + height : ''} cm`;

      if (quantity && step.querySelector('.summary-quantity span') ) {
        step.querySelector('.summary-quantity span').innerHTML = quantity;
      }

    }

    getExtraProductInfo(index, step) {
      const currentStep = document.querySelector(`.step #step-${index}`);
      const inputSelected = currentStep.querySelector('input:checked');
      if (inputSelected && currentStep.querySelector('input:checked').value === 'true') {
        if (Number(inputSelected.dataset.itemQuantity) > 1) {
          step.querySelector('span').innerHTML = 'Yes x' + inputSelected.dataset.itemQuantity;
        } else {
          step.querySelector('span').innerHTML = 'Yes';
        }
      } else {
        step.querySelector('span').innerHTML = 'No';
      }
    }


    updateSteps() {
      this.summarySteps.forEach((step) => {
        let index = step.dataset.step;
        let type = step.querySelector('span').dataset.type;
        if (type === 'collection') {
          this.getCollectionInfo(index, step);
        } else if (type === 'properties') {
          this.getPropertiesInfo(index, step);
        } else if (type === 'variants') {
          this.getVariantsInfo(index, step);
        } else if (type === 'custom') {
          this.getCustomDimensionsInfo(index, step);
        } else if (type === 'product') {
          this.getExtraProductInfo(index, step);
        }
      })
    }

  });
}